import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { AgGridReact } from "ag-grid-react";
import { getEmployeeList } from "src/apis/employeeApi";
import { getItemPopupList } from "src/apis/itemApi";
import { BRDiv, inputFormHeightOption, SmallTitleSpan } from "src/components/common/common";
import { CheckboxButtonForm } from "src/components/common/form/checkbox/CheckboxButtonForm";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig, InfoFieldHandlers } from "src/types/info-form";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { formatDate, formatDateWithTime, validateString } from "src/utils/string/stringUtil";
import { KSK2110_R01DetailDto, KSK2110_R01HeaderDto, KSK2110_R01LotDto } from "./Dto_KSK2110_R01";
import { useKSK2110_R01Store } from "./Store_KSK2110_R01";
import { InputForm_KSK2110_R01 } from "./InputForm_KSK2110_R01";
import { showWarning } from "src/utils/toast/toastUtil";
import { KioskSwitchButtonForm } from "src/components/common/form/KioskSwitchButtonForm";



interface Props {
	editable: boolean

	defaultKSK2110_R01HeaderRow: KSK2110_R01HeaderDto;
	handleWorkTimeClick: (productOrderNo: string, processType: 'workStart' | 'workEnd', manualTime?: Date) => void;

	handleFetchBomProductList: ( itemCd: string, warehouseCd: string, logicCenter: string ) => void;
	handleFetchLotList: (onFail?: () => void) => void;

	getProductWorkFieldHandlers: (fieldName: string) => InfoFieldHandlers;
	validateWorkStartEnd: (time: string | undefined) => boolean;
}

export const Info_KSK2110_R01 = (props: Props) => {

	const { editable, 
		defaultKSK2110_R01HeaderRow,
		handleWorkTimeClick,
		handleFetchBomProductList, handleFetchLotList,
		getProductWorkFieldHandlers,
		validateWorkStartEnd,
	} = props;

	// const { companyList } = useCompanyStore();
	const { itemStatusList, jobTeamList, wmsCdList, compCdList, employeeCdList, workPlaceList, warehouseCdList,  } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { 
			KSK2110_R01Filter, setKSK2110_R01Filter,
			// selectedKSK2110_R01,
			editKSK2110_R01, setEditKSK2110_R01,
			isInitialLoad, setIsInitialLoad,
			KSK2110_R01LotList, setKSK2110_R01LotList,
	} = useKSK2110_R01Store();

	// 매출일자 달력 팝업 상태
	const [productDtPickerVisible, setProductDtPickerVisible] = useState(false);
	const [productDtPickerPos, setProductDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});


	const workEmpInfoHandleFoucsId = 'infoWorkEmpInput';
	const [searchTrigger, setSearchTrigger] = useState(false);

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
            category: "품목",
            focusId: "itemCd_search",
			responseMapping: {
				itemCd : 'itemCd',
				itemNm : 'itemNm',
				itemSpec : 'itemSpec',
				itemUnit : 'itemUnit'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getItemPopupList(code, '', '', '');
				return employeeResponse.data.data.find(value => value.itemCd === code);
			}
        },
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: workEmpInfoHandleFoucsId,
			responseMapping: {
				empNo: 'orderEmp',
				empNm: 'orderEmpNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			}
		},
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editKSK2110_R01,
		setEditData: setEditKSK2110_R01,
		defaultData: defaultKSK2110_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2110_R01'
	});

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		// 초기 로드 시에는 Content에서 이미 호출했으므로 건너뜁니다.
		if (isInitialLoad) {
			setIsInitialLoad(false);
			return;
		}

		if(editKSK2110_R01?.itemCd && editKSK2110_R01?.outWarehouseCd && editKSK2110_R01?.logicCenter) {
			handleFetchBomProductList(editKSK2110_R01.itemCd, editKSK2110_R01.outWarehouseCd, editKSK2110_R01.logicCenter);
		}
	}, [editKSK2110_R01?.outWarehouseCd, editKSK2110_R01?.logicCenter])

	useEffect(() => {
		if (searchTrigger) {
			handleFetchLotList();
			setSearchTrigger(false);
		}
	}, [searchTrigger]);

	const handleDateChange = useCallback((field: keyof KSK2110_R01HeaderDto, value: any) => {
		setEditKSK2110_R01({
			...defaultKSK2110_R01HeaderRow,
			...editKSK2110_R01,
			[field]: value
		});
	}, [editKSK2110_R01, defaultKSK2110_R01HeaderRow, setEditKSK2110_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		let closeTag = editKSK2110_R01?.closeTag || 'N';
		if(Number(editKSK2110_R01?.orderQty) === Number(editKSK2110_R01?.productQty)) {
			closeTag = 'Y';
		}else {
			closeTag = 'N';
		}

		//상태값이 바뀌면 lot리스트의 itemStatus의 값도 바뀌어야 함
		if(name === 'itemStatus') {
			const newLotList = KSK2110_R01LotList.map((item: KSK2110_R01LotDto) => ({
				...item,
				itemStatus: value as string
			}));
			setKSK2110_R01LotList(newLotList);
		}

		setEditKSK2110_R01({
			...defaultKSK2110_R01HeaderRow,
			...editKSK2110_R01,
			[name]: value,
			closeTag: closeTag
		});
	}, [editKSK2110_R01, defaultKSK2110_R01HeaderRow, KSK2110_R01LotList, setEditKSK2110_R01, setKSK2110_R01LotList]);

	return (
		<div className="w-full h-full flex flex-col gap-[4px]" ref={containerRef}>
				<div
					className="h-full max-h-full flex flex-wrap content-start overflow-y-auto"
					ref={infoRef}
				>
					<InputForm_KSK2110_R01 
						setSearchTrigger={setSearchTrigger}
						handleChange={handleChange} 
						handleFetchLotList={handleFetchLotList} 
						getProductWorkFieldHandlers={getProductWorkFieldHandlers}
					/>
					<BRDiv />
					<DropDownForm
						title="작업정보"
						name="workplaceCd"
						initLabelLess={true}
						value={editKSK2110_R01?.workplaceCd}
						data={workPlaceList}
						editable={false}
						onChange={handleChange}
					/>
					<SingleDateForm
						title="생산일자"
						value={editKSK2110_R01?.productDt ? new Date(editKSK2110_R01.productDt) : undefined}
						setValue={(value: Date | undefined) => handleDateChange('productDt', formatDate(value))}
						editable={false}
						visible={productDtPickerVisible} setVisible={setProductDtPickerVisible}
						onChange={handleChange}
						pickerPos={productDtPickerPos} setPickerPos={setProductDtPickerPos}
					/>
					<BRDiv />
					<CodeForm
						label="품목코드"
						value={editKSK2110_R01?.itemCd || ""}
						custNmValue={editKSK2110_R01?.itemNm || ""}
						editable={false}
						name="itemCd"
						handleChange={
							() => { }
							// handleChange
						}
						onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
						onKeyDown={() => { 
							// getFieldHandlers('itemCd').onEnterKeyDown
						}}
						wrapperOption = {{
							wrapperStyle: "w-[700px] min-w-[700px] mr-[10px] mb-[5px]",
							titleStyle: "w-[150px] min-w-[150px] text-left",
							codeInputStyle: "w-[200px] min-w-[200px]",
							custNmInputStyle: "w-[355px] min-w-[355px]"
						}}
					/>
					<BRDiv />
					<InputForm title="규격" value={editKSK2110_R01?.itemSpec || ""}
						editable={false}
						name="itemSpec"
						onChange={handleChange} />
					<InputForm title="단위" value={editKSK2110_R01?.itemUnit || ""}
						editable={false}
						name="itemUnit"
						onChange={handleChange} />
					<BRDiv />
					<InputForm title="작업지시잔량" value={editKSK2110_R01?.orderQty || 0}
						editable={false}
						name="orderQty"
						onChange={handleChange} />
					<BRDiv />
					{/* <InputForm title="작업완료량" value={editKSK2110_R01?.resultQty || 0}
						editable={false}
						name="resultQty"
						onChange={handleChange} />
					<BRDiv /> */}
					<InputForm title="생산양품량" value={editKSK2110_R01?.productQty || 0}
						editable={false}
						name="productQty"
						onChange={handleChange} />
					<InputForm title="생산불량수량" value={editKSK2110_R01?.badQty || 0}
						editable={false}
						name="badQty"
						onChange={handleChange} />
					<BRDiv />
					
					<DropDownForm
						title="작업팀"
						name="jobTeam"
						initLabelLess={true}
						value={editKSK2110_R01?.jobTeam}
						data={jobTeamList}
						editable={true}
						onChange={handleChange}
					/>
					<DropDownForm
						title="등급"
						name="itemStatus"
						initLabelLess={true}
						value={editKSK2110_R01?.itemStatus}
						data={itemStatusList}
						editable={true}
						onChange={handleChange}
					/>
					<BRDiv />
					<CodeForm
						label="작업자"
						value={editKSK2110_R01?.orderEmp || ""}
						custNmValue={editKSK2110_R01?.orderEmpNm || ""}
						editable={true}
						name="orderEmp"
						handleChange={handleChange}
						onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
						onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
					/>
					<InputForm title="설비Count" value={editKSK2110_R01?.plcCount ?? 0}
						editable={false}
						name="plcCount"
						onChange={handleChange} />
					<BRDiv />
					<KioskSwitchButtonForm
						title="라벨자동출력"
						name="labelPrintAuto"
						value={KSK2110_R01Filter.labelPrintAuto as 'Y' | 'N'}
						onChange={(name, value) => setKSK2110_R01Filter({ ...KSK2110_R01Filter, [name]: value })}
					/>

				</div>
		</div>
	)
}
